import { CollapseTransition } from "@ivanv/vue-collapse-transition";

export default {
  components: {
    CollapseTransition,
  },
  props: {
    title: String,
    values: {
      type: Array,
      default: () => [],
    },
    defaultOpen: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  created() {
    this.isOpen = this.defaultOpen;
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
  },
};
